module.exports = __webpack_public_path__ + "static/media/r20.68c09d5d.jpeg";